import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Img from 'react-image'
import { Transition } from 'react-transition-group'
import Loader from '../../_common/Loader/Loader'
import './style.css'

PicturePreview.propTypes = {
  preview: PropTypes.string,
  style: PropTypes.shape({}),
  alt: PropTypes.string,
  onLoad: PropTypes.func
}

function PicturePreview (props) {
  const {
    preview, onLoad, style, alt
  } = props
  return (
    <Img
      onLoad={onLoad}
      className='gallery-img-elt gallery-img-preview'
      style={style}
      src={preview}
      alt={`${alt} preview`}
      loader={<Loader />}
    />
  )
}

class GalleryPicture extends PureComponent {
  static propTypes = {
    sm: PropTypes.string,
    preview: PropTypes.string,
    alt: PropTypes.string
  }

  state = {
    previewLoaded: false
  }

  render () {
    const { sm, alt } = this.props
    const { previewLoaded } = this.state
    const duration = 0
    const defaultStyle = {
      transition: `opacity ${duration}ms ease-in-out`,
      opacity: 0
    }

    const transitionStyles = {
      entering: { opacity: 1 },
      entered: { opacity: 1 },
      exiting: { opacity: 0 },
      exited: { opacity: 0 }
    }
    return (
      <div
        className='gallery-img'
      >
        <PicturePreview
          onLoad={() => {
            this.setState({ previewLoaded: true })
          }}
          {...this.props}
        />
        {previewLoaded && (
          <Transition in={previewLoaded} timeout={50}>
            {state => (
              <Img
                className='gallery-img-elt gallery-img-loaded'
                src={`${sm}`}
                alt={alt}
                // decode={false}
                style={{
                  ...defaultStyle,
                  ...transitionStyles[state]
                }}
              />
            )}
          </Transition>
        )}
      </div>
    )
  }
}

export default GalleryPicture
